export { SidebarMedia as SidebarV2Media } from './SidebarMedia';
export { SidebarMediaController as SidebarV2MediaController } from './SidebarMediaController';
export { SidebarMediaTitle as SidebarV2MediaTitle } from './SidebarMediaTitle';
